module.exports = __webpack_public_path__ + "img/product10.a0fd2de9.png";